import { formatRequestsListTable } from '../resources/js/helpers/tableUtils'
import { put, getAll, clear } from './utils/transactionHelpers'

function sanitizeData(data) {
    return data.map(item => {
        const sanitizedItem = { ...item }
        const cleanObject = obj => {
            Object.keys(obj).forEach(key => {
                const value = obj[key]
                if (typeof value === 'object' && value !== null) {
                    if (Array.isArray(value)) {
                        obj[key] = value.map(item => cleanObject(item))
                    } else if (value instanceof Date) {
                        obj[key] = value.toISOString()
                    } else {
                        obj[key] = cleanObject({ ...value })
                    }
                } else if (
                    typeof value === 'function' ||
                    typeof value === 'symbol' ||
                    typeof value === 'undefined'
                ) {
                    delete obj[key]
                }
            })
            return obj
        }

        return cleanObject(sanitizedItem)
    })
}

export async function saveRequests(requests, type) {
    try {
        const sanitizedRequests = sanitizeData(requests).map(
            (request, index) => ({
                ...request,
                type,
                orderIndex: index,
            }),
        )

        const putPromises = sanitizedRequests.map(request =>
            put('requests', request),
        )
        await Promise.all(putPromises)
    } catch (error) {
        console.error('Error saving requests:', error)
        throw error
    }
}

export async function getRequestsByType(type) {
    try {
        // Get all requests and filter by type
        const allRequests = await getAll('requests')
        return allRequests
            .filter(request => request.type === type)
            .sort((a, b) => a.orderIndex - b.orderIndex) // Preserve sorting by orderIndex
    } catch (error) {
        console.error('Error retrieving requests by type:', error)
        throw error
    }
}

export async function saveAllRequestsBatch(requestsByType) {
    try {
        const allRequests = Object.entries(requestsByType).flatMap(
            ([type, requests]) =>
                sanitizeData(requests).map((request, index) => ({
                    ...request,
                    type,
                    orderIndex: index,
                })),
        )

        const putPromises = allRequests.map(request => put('requests', request))
        await Promise.all(putPromises)
    } catch (error) {
        console.error('Error saving all requests:', error)
        throw error
    }
}

export const saveAllRequests = async response => {
    try {
        const {
            openRequests = [],
            closedRequests = [],
            estimateRequests = [],
        } = response.data

        const requestsByType = {
            openRequest: formatRequestsListTable(openRequests, 'openRequest'),
            closedRequest: formatRequestsListTable(
                closedRequests,
                'closedRequest',
            ),
            estimateRequest: formatRequestsListTable(
                estimateRequests,
                'estimateRequest',
            ),
        }

        await saveAllRequestsBatch(requestsByType)
    } catch (error) {
        console.error('Error saving all requests:', error)
        throw error
    }
}

export const deleteAllRequests = async () => {
    try {
        await clear('requests')
        console.log('All requests deleted successfully')
    } catch (error) {
        console.error('Error deleting requests:', error)
        throw error
    }
}
